export default __webpack_public_path__ + "static/media/garden-loader.9b5275b8.gif";